import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  b64toFile (dataURI) {
    // convert the data URL to a byte string
    const byteString = atob(dataURI.split(',')[1])

    // pull out the mime type from the data URL
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // Convert to byte array
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    // Create a blob that looks like a file.
    const blob = new Blob([ab], { type: mimeString })
    blob.lastModifiedDate = (new Date()).toISOString()
    blob.name = 'file'

    // Figure out what extension the file should have
    switch (blob.type) {
      case 'image/jpeg':
        blob.name += '.jpg'
        break
      case 'image/png':
        blob.name += '.png'
        break
      case 'image/gif':
        blob.name += '.gif'
        break
    }

    return blob
  },

  async uploadPicture (file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()

      const fileObj = this.b64toFile(file)
      formData.append('file', fileObj)
      axiosInstance.post('/stc/files/', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
